// removed by extract-text-webpack-plugin
module.exports = {"blokkSvg":"nrk-v17-static-blokkSvg"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/enblokksvisning/Blokk/svg/index.css
// module id = 284
// module chunks = 6 7